import type { ReactElement } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { SearchInput } from "@similarweb/ui-components";

import { StyledFilterSearchBoxWrapper } from "./styles";

interface IFilterSearchBoxProps {
    onChange: (searchText: string) => void;
    onFocus?: VoidFunction;
}

export const FilterSearchBox = ({ onChange, onFocus }: IFilterSearchBoxProps): ReactElement => {
    const { translate } = useTranslate();

    return (
        <StyledFilterSearchBoxWrapper>
            <SearchInput
                placeholder={translate("si.lead_gen_filters.search.placeholder")}
                debounce={0}
                onChange={onChange}
                onFocus={onFocus}
            />
        </StyledFilterSearchBoxWrapper>
    );
};